//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  BatchCreateConnectionConfig,
  ConnectionConfig,
} from '@bvengineering/universal-scheduling-gateway-service-types';

import Cuid from '@models/Cuid';
import DraftId from '@models/DraftId';
import PostableId from '@models/PostableId';
import { Opaque } from '@utils/opaque';
import { OmitStrict } from '@utils/types/OmitStrict';

export type ConnectionId = Opaque<number, 'ConnectionId'>;

export enum UniversalConnectionType {
  BatchCreate = 'batch-create',
}

export enum UniversalConnectionConfigType {
  BatchCreate = 'v1:batch-create',
}

export type TConnectionConfig = IBatchCreateConnectionConfig;

interface IConnectionConfig extends OmitStrict<ConnectionConfig, '@type'> {
  '@type': UniversalConnectionConfigType;
}

export interface IBatchCreateConnectionConfig
  extends IConnectionConfig,
    OmitStrict<
      BatchCreateConnectionConfig,
      '@type' | 'batchCuids' | 'batchScheduledTime'
    > {
  '@type': UniversalConnectionConfigType.BatchCreate;
  batchCuids: Cuid[];
  batchScheduledTime?: Date;
}

export type TPostConnection = IBatchCreateConnection;

interface IPostConnection {
  id: ConnectionId;
  connectionType: UniversalConnectionType;
  configuration?: TConnectionConfig;
  connectedPostableIds: PostableId[];
  connectedDraftIds: DraftId[];
}

export interface IBatchCreateConnection extends IPostConnection {
  config?: IBatchCreateConnectionConfig;
  connectionType: UniversalConnectionType.BatchCreate;
}
